import React, { useEffect, useState } from 'react';
import { FaUsers, FaMoneyBillWave, FaBus, FaListAlt, FaUniversity, FaChalkboardTeacher, FaCoins, FaWallet, FaMobileAlt } from 'react-icons/fa';
import Dashboard from './Dashboard';
import '../styles/HomePage.css';
import logo from '../styles/school-logo.jpeg';
import { SCHOOL_NAME } from '../config/school';

const HomePage = () => {
  const [stats, setStats] = useState({
    totalStudents: 0,
    totalFees: 0,
    totalVanFees: 0,
    totalOtherFees: 0,
    totalExpenses: 0,
    totalCoachingStudents: 0,
    totalCoachingFees: 0,
    totalCashCollected: 0,
    totalUPICollected: 0,
  });

  useEffect(() => {
    fetch('/backend/api/dashboard_stats.php', {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => setStats(data))
      .catch(err => console.error('Error loading dashboard stats:', err));
  }, []);

  const summaryData = [
    { label: 'Total Students Registered', value: stats.totalStudents, icon: <FaUsers /> },
    { label: 'Total Fees Collected', value: `₹ ${stats.totalFees}`, icon: <FaMoneyBillWave /> },
    { label: 'Total Van Fees Collected', value: `₹ ${stats.totalVanFees}`, icon: <FaBus /> },
    { label: 'Total Other Fees Collected', value: `₹ ${stats.totalOtherFees}`, icon: <FaListAlt /> },
    { label: 'Total School Expenses', value: `₹ ${stats.totalExpenses}`, icon: <FaUniversity /> },
    { label: 'Total Coaching Students', value: stats.totalCoachingStudents, icon: <FaChalkboardTeacher /> },
    { label: 'Total Coaching Fees Collected', value: `₹ ${stats.totalCoachingFees}`, icon: <FaCoins /> },
    { label: 'Total Collected in Cash', value: `₹ ${stats.totalCashCollected}`, icon: <FaWallet /> },
    { label: 'Total Collected via UPI', value: `₹ ${stats.totalUPICollected}`, icon: <FaMobileAlt /> },
  ];

  return (
    <Dashboard>
      <div className="home-content">
        <div className="home-header">
          <img src={logo} alt="School Logo" className="school-logo" />
          <div>
            <h1>Welcome to {SCHOOL_NAME}</h1>
            <p>Fee Management System Dashboard</p>
          </div>
        </div>

        <div className="summary">
          {summaryData.map((item, index) => (
            <div className="summary-item" key={index}>
              <div className="summary-icon">{item.icon}</div>
              <div className="summary-text">
                <div className="summary-label">{item.label}</div>
                <div className="summary-value">{item.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Dashboard>
  );
};

export default HomePage;
